import { useEffect, useState } from 'react'
import { axios } from 'api'

export const useMaintenance = () => {
  const [isMaintenance, setIsMaintenance] = useState(false)
  const [maintenanceTitle, setMaintenanceTitle] = useState('')
  const [maintenanceDescription, setMaintenanceDescription] = useState('')
  useEffect(() => {
    const checkMaintenance = async () => {
      const response = await axios.get('/maintenance')
      if (response.status === 200) {
        if (response.data?.isMaintenance) {
          setIsMaintenance(true)
          setMaintenanceTitle(response.data.maintenanceTitle)
          setMaintenanceDescription(response.data.maintenanceDescription)
        }
      } else {
        console.error(
          'Failed to check maintenance mode: Unexpected status',
          response.status
        )
      }
    }
    checkMaintenance()
  }, [])
  return { isMaintenance, maintenanceTitle, maintenanceDescription }
}
